// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"131":"ff6feeae","171":"2e6f3038","200":"1e829a4b","376":"b0648eb1","377":"a19a063e","491":"f6b307fd","518":"af603923","666":"d3bc61e2","685":"59b4669d","738":"2fdbbb42","758":"bd0c0285","840":"deb6af6b","841":"2cf639dc","946":"f7981f5f"}[chunkId] + ".js";
};